export const nextQueryKeys = ['next'] as const
type NextQueryKeys = typeof nextQueryKeys[number]
export type NextQueryItem = Record<NextQueryKeys, string>

export const alertQueryKeys = ['alert'] as const
type AlertQueryKeys = typeof alertQueryKeys[number]
export type AlertQueryItem = Record<AlertQueryKeys, string>